import React, { useEffect, useState } from 'react'
import ThemeMaker from '../../components/thememaker'
import { Flex, Space, Table, Tag } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import jwt_decode from "jwt-decode";
import { config } from '../../utils/config';
import axios from 'axios';
import { HiPencilSquare } from "react-icons/hi2";
import Serviceability from './Serviceability.jsx';

export default function Fulfillment() {
    const { apiEndpoint } = config;
    const { id } = useParams();
    const { locationId } = useParams();
    const Router = useHistory();
    const [showForm, setShowForm] = useState(false)

    let rawToken = sessionStorage.getItem("us_st_d");
    var decode = jwt_decode(rawToken);

    const columns = [
        {
            title: "Fulfillment Type",
            dataIndex: "fulfillment_type",
        },
        {
            title: "Payment Mode",
            dataIndex: "payment_mode",
        },
        {
            title: "Method",
            dataIndex: "fulfillment_method",
        },
        {
            title: "Delivery Fee",
            dataIndex: "delivery_fee",
        },
        {
            title: "Packing Charge",
            dataIndex: "packing_charge",
        },
        {
            title: "miscellaneous Charge",
            dataIndex: "miscellaneous_charge",
        },
        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <div className="d-flex align-items-center gap-2">
                    <span
                        className="text-success"
                        onClick={() => getfullfillmentById(record?.id)}
                        style={{ cursor: "pointer" }}>
                        <HiPencilSquare size={18} />
                    </span>
                </div>
            ),
        },
    ];

    const rawData = {
        fulfillment_type: "",
        payment_mode: "",
        fulfillment_method: "",
        delivery_fee: 0,
        packing_charge: 0,
        miscellaneous_charge: 0,
    }
    const rawErrorData = {
        fulfillment_type: false,
        payment_mode: false,
        fulfillment_method: false,
        delivery_fee: false,
        packing_charge: false,
        miscellaneous_charge: false,
        // seller_commision: false,
    }
    const [sellerData, setSellerData] = useState(rawData);
    const [sellerDataError, setSellerDataError] = useState(rawErrorData);

    const inputHandler = (e) => {
        setSellerData({ ...sellerData, [e.target.name]: e.target.value });
    }
    const errorHandler = (e) => {
        if (e.target.value) {
            setSellerDataError({ ...sellerDataError, [e.target.name]: "valid" });
        } else {
            setSellerDataError({ ...sellerDataError, [e.target.name]: true });
        }
    }

    // console.log("isGSTValid--->", isgstValid)
    // const newFulfillmentCreateHandler = async () => {
    //     try {
    //         const { payment_mode, fulfillment_method, delivery_fee, packing_charge, miscellaneous_charge, status } = sellerData;
    //         if (payment_mode && fulfillment_method && delivery_fee && packing_charge && miscellaneous_charge && status) {
    //             // dispatch(registerSeller(sellerData));
    //             console.log(">>>>>>>>>>>>", sellerData)
    //         } else {
    //             toast.error("Please fill all the fields !");
    //         }
    //     } catch (err) {
    //         console.log(err);
    //         toast.error("Something went wrong, please try later!")
    //     }

    // }

    const newFulfillmentCreateHandler = async () => {
        try {
            const {
                fulfillment_type,
                payment_mode,
                fulfillment_method,
                delivery_fee,
                packing_charge,
                miscellaneous_charge
            } = sellerData;

            if (
                fulfillment_type &&
                payment_mode &&
                fulfillment_method &&
                delivery_fee !== "" &&
                packing_charge !== "" &&
                miscellaneous_charge !== ""
            ) {

                const payload = {
                    warehouse_id: id,
                    warehouse_location_id: locationId,
                    fulfillment_configs: [
                        {
                            fulfillment_type: fulfillment_type,
                            payment_mode: payment_mode,
                            fulfillment_method: fulfillment_method,
                            is_active: true,
                            charges: {
                                delivery_fee: Number(delivery_fee),
                                packing_charge: Number(packing_charge),
                                miscellaneous_charge: Number(miscellaneous_charge)
                            }
                        }
                    ]
                };

                const response = await axios.post(
                    `${apiEndpoint}/update-warehouse-fulfillment`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-Custom-Authorization": `Bearer ${rawToken}`
                        }
                    }
                );
                toast.success(response?.data?.message || "Fulfillment updated successfully");
            } else {
                toast.error("Please fill all the fields !");
            }
            getAllFulfillments();
            setShowForm(false);
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong, please try later!");
        }
    };

    const [data, setData] = useState([]);
    const getAllFulfillments = async () => {
        try {
            const response = await axios.get(
                `${apiEndpoint}/get-warehouse-fulfillment?warehouse_id=${id}&warehouse_location_id=${locationId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    }
                }
            );
            console.log("Fulfillments data ---->", response?.data?.data);
            setData(response?.data?.data);
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong while fetching fulfillments!");
        }
    };

    const [editId, setEditId] = useState(null);

    const getfullfillmentById = async (fulfillmentId) => {
        try {
            const response = await axios.get(
                `${apiEndpoint}/get-warehouse-fulfillment?id=${fulfillmentId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "X-Custom-Authorization": `Bearer ${rawToken}`
                    }
                }
            );
            setShowForm(true);
            setSellerData({
                fulfillment_type: response?.data?.data?.fulfillment_type || "",
                payment_mode: response?.data?.data?.payment_mode || "",
                fulfillment_method: response?.data?.data?.fulfillment_method || "",
                delivery_fee: response?.data?.data?.delivery_fee || 0,
                packing_charge: response?.data?.data?.packing_charge || 0,
                miscellaneous_charge: response?.data?.data?.miscellaneous_charge || 0,
            });
            setEditId(fulfillmentId);
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong while fetching fulfillment details!");
        }
    }

    useEffect(() => {
        if (id && locationId) {
            getAllFulfillments();
        }
    }, [id, locationId])

    const fulfillmentTypeOptions = [
        { label: "On Order", value: "ON-ORDER" },
        { label: "Cash On Delivery", value: "COD" }
    ];

    const paymentModeOptions = [
        { label: "Full Payment", value: "FULL-PAYMENT" },
        { label: "Part Payment", value: "PART-PAYMENT" }
    ];

    const fulfillmentMethodOptions = [
        { label: "Delivery", value: "Delivery" },
        { label: "Self Pickup", value: "Self-Pickup" }
    ];

    return (
        <ThemeMaker>
            <div className="row m-0 w-100 mt-1">
                <div className="col-md-12">
                    <div className=" mb-4">
                        <div>

                        </div>
                        <div className="card-body" style={{ height: "78vh", overflow: "scroll", scrollbarWidth: "none" }}>
                            <div className="row">
                                {!showForm && <div className='w-100'>
                                    <div className='d-flex justify-content-end'>
                                        <Tag color='geekblue' style={{ cursor: "pointer" }} onClick={() => {
                                            setShowForm(true);
                                            setEditId(null);
                                        }}>
                                            Add fulfillment
                                        </Tag>
                                    </div>

                                    <div className='mt-2'>
                                        <Table columns={columns} dataSource={data} rowKey="id" />
                                    </div>
                                </div>}

                                {showForm && <div>
                                    <div className='d-flex justify-content-end'>
                                        <Tag color='geekblue' style={{ cursor: "pointer" }} onClick={() => { setShowForm(false); setSellerData(rawData) }}>
                                            All fulfillments
                                        </Tag>
                                    </div>
                                    <div className="card-body" style={{ height: "80vh", overflow: "scroll", scrollbarWidth: "none" }}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p className="genericlabel"> Fulfillment type <span className="text-danger" >*</span>
                                                    {
                                                        sellerDataError?.fulfillment_type !== "valid" && sellerDataError?.fulfillment_type !== false ? (
                                                            <span className="text-danger tiny_size" > This field is required ! </span>
                                                        ) : null
                                                    }
                                                </p>
                                                <div className="form-group">
                                                    <select
                                                        name="fulfillment_type"
                                                        className="form-control"
                                                        disabled={editId ? true : false}
                                                        value={sellerData.fulfillment_type}
                                                        onChange={inputHandler}
                                                        onBlur={errorHandler}
                                                    >
                                                        <option value="">Select fulfillment type</option>

                                                        {fulfillmentTypeOptions.map((item) => (
                                                            <option key={item.value} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <p className="genericlabel"> Payment mode <span className="text-danger" >*</span>
                                                    {
                                                        sellerDataError?.payment_mode !== "valid" && sellerDataError?.payment_mode !== false ? (
                                                            <span className="text-danger tiny_size" > This field is required ! </span>
                                                        ) : null
                                                    }
                                                </p>
                                                <div className="form-group">
                                                    <select
                                                        name="payment_mode"
                                                        disabled={editId ? true : false}
                                                        className="form-control"
                                                        value={sellerData.payment_mode}
                                                        onChange={inputHandler}
                                                        onBlur={errorHandler}
                                                    >
                                                        <option value="">Select payment mode</option>

                                                        {paymentModeOptions.map((item) => (
                                                            <option key={item.value} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <p className="genericlabel mb-2"> Fulfillment method <span className="text-danger" >*</span>
                                                    {
                                                        sellerDataError?.fulfillment_method !== "valid" && sellerDataError?.fulfillment_method !== false ? (
                                                            <span className="text-danger tiny_size" > This field is required ! </span>
                                                        ) : null
                                                    }
                                                </p>
                                                <div className="form-group">
                                                    <select
                                                        name="fulfillment_method"
                                                        className="form-control"
                                                        disabled={editId ? true : false}
                                                        value={sellerData.fulfillment_method}
                                                        onChange={inputHandler}
                                                        onBlur={errorHandler}
                                                    >
                                                        <option value="">Select fulfillment method</option>

                                                        {fulfillmentMethodOptions.map((item) => (
                                                            <option key={item.value} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="genericlabel">Delivery charge <span className="text-danger" >*</span>
                                                        {
                                                            sellerDataError?.delivery_fee !== "valid" && sellerDataError?.delivery_fee !== false ? (
                                                                <span className="text-danger tiny_size" > This field is required ! </span>
                                                            ) : null
                                                        }
                                                    </label>
                                                    <input type="number" className="form-control" name="delivery_fee" placeholder="Enter delivery charge"
                                                        value={sellerData.delivery_fee}
                                                        onChange={(e) => inputHandler(e)}
                                                        onBlur={(e) => errorHandler(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="genericlabel">Packing charge <span className="text-danger" >*</span>
                                                        {
                                                            sellerDataError?.packing_charge !== "valid" && sellerDataError?.packing_charge !== false ? (
                                                                <span className="text-danger tiny_size" > This field is required ! </span>
                                                            ) : null
                                                        }
                                                    </label>
                                                    <input type="number" className="form-control" name="packing_charge" placeholder="Enter packing charge"
                                                        value={sellerData.packing_charge}
                                                        onChange={(e) => inputHandler(e)}
                                                        onBlur={(e) => errorHandler(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="genericlabel">Miscellaneous charge <span className="text-danger" >*</span>
                                                        {
                                                            sellerDataError?.miscellaneous_charge !== "valid" && sellerDataError?.miscellaneous_charge !== false ? (
                                                                <span className="text-danger tiny_size" > This field is required ! </span>
                                                            ) : null
                                                        }
                                                    </label>
                                                    <input type="number" className="form-control" name="miscellaneous_charge" placeholder="Enter miscellaneous charge"
                                                        value={sellerData.miscellaneous_charge}
                                                        onChange={(e) => inputHandler(e)}
                                                        onBlur={(e) => errorHandler(e)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12 d-flex justify-content-center mt-4">
                                                <button
                                                    type="submit"
                                                    className="p-2 px-4 btn btn-primary"
                                                    style={{ borderRadius: "20px" }}
                                                    onClick={newFulfillmentCreateHandler}
                                                >
                                                    {editId ? "Update" : "Submit"}
                                                </button>
                                            </div>
                                            {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                        </div>

                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </ThemeMaker>
    )
}
